import React, { useEffect, useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCloseOutline,
  IoLockClosedOutline,
  IoPlayCircleOutline,
} from "react-icons/io5";
import "./pages.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { url } from "../../utilis/contant";
import api from "../../utilis/api";

const REPLAY_PRICE = 47;

const Replays = () => {
  const { token, user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const [recordings, setRecordings] = useState([]);
  const [video, setVideo] = useState([]);
  const [bookedSlots, setBookedSlots] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  const [videoModal, setVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({ url: "", title: "" });
  const [payingFor, setPayingFor] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);

  const hasFreeAccess =
    subscription?.hasSubscription && subscription?.price === 79.99;

  // Fetch subscription
  const fetchBookedSlots = async () => {
    try {
      const res = await api.get("/booking", {
        params: { studentId: user._id },
      });
      if (res.data.success) {
        console.log(res.data.data);
        setBookedSlots(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    if (user && user._id) fetchBookedSlots();
  }, [user]);
  useEffect(() => {
    if (!token) return;
    const fetchSub = async () => {
      try {
        const res = await api.get("/payments/my-subscription", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = res.data;

        setSubscription(data);
      } catch (err) {
        console.error("Subscription fetch failed:", err);
      }
    };
    fetchSub();
  }, [token]);

  // ✅ Fetch real recordings from backend
  useEffect(() => {
    if (!token || !user?._id) return;
    const fetchRecordings = async () => {
      try {
        const res = await api.get("/booking/recordings", {
          params: {
            studentId: user._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = res.data;

        if (data.success && Array.isArray(data.data)) {
          setRecordings(data.data);
        } else {
          setRecordings([]);
        }
      } catch (err) {
        console.error("Failed to fetch recordings:", err);
        setRecordings([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRecordings();
  }, [token, user]);

  const openVideoModal = (videoUrl, title) => {
    setCurrentVideo({ url: videoUrl, title });
    setVideoModal(true);
  };

  const handlePayForReplay = async (lesson) => {
    if (!token) {
      navigate("/");
      return;
    }
    setPayingFor(lesson.id);
    try {
      const res = await fetch(`${url}/api/payments/create-lesson-checkout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          planType: "replay",
          lessonId: lesson.id,
          lessonTitle: lesson.title,
          finalPrice: REPLAY_PRICE,
          originalPrice: REPLAY_PRICE,
          discountRate: 0,
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert(`Error: ${data.message || "Could not start payment"}`);
      }
    } catch (err) {
      alert(`Something went wrong: ${err.message}`);
    } finally {
      setPayingFor(null);
    }
  };
  const formatSlotTime = (time, duration) => {
    if (!time) return "N/A";

    const formatHour = (h) => {
      if (!h) return "";
      const [hourStr, minStr] = h.trim().split(":");
      const hour = parseInt(hourStr);
      const minute = parseInt(minStr) || 0;
      const ampm = hour >= 12 ? "PM" : "AM";
      const h12 = hour % 12 === 0 ? 12 : hour % 12;
      return `${h12}:${minute.toString().padStart(2, "0")} ${ampm}`;
    };

    // Old format: "09:00-10:00"
    if (time.includes("-")) {
      const [start, end] = time.split("-");
      return `${formatHour(start)} - ${formatHour(end)}`;
    }

    // New format: "09:00" — calculate end from duration
    if (duration) {
      const [h, m] = time.split(":").map(Number);
      const totalMin = h * 60 + m + parseInt(duration);
      const endH = String(Math.floor(totalMin / 60)).padStart(2, "0");
      const endM = String(totalMin % 60).padStart(2, "0");
      return `${formatHour(time)} - ${formatHour(`${endH}:${endM}`)}`;
    }

    return formatHour(time);
  };
  const hasRecording = bookedSlots?.some((rec) => rec.recordingUrl?.trim());

  //  Subscription Video

  const STRIPE_PRICE_IDS = {
    // monthly: "price_1TMBLp16booVXHu6Ya9MUeuA",
    // yearly: "price_1TMBML16booVXHu6mWO5XSxx",
    // Live Key
    monthly: "price_1TLq02IdDYF1KaufYbynIvZl",
    yearly: "price_1TLq0dIdDYF1KaufyVPlUhHa",
  };

  const handleSubscribe = async (planId) => {
    if (!token) {
      alert("Please login first to subscribe!");
      navigate("/");
      return;
    }
    console.log(planId);
    if (planId !== "monthly" && planId !== "yearly") {
      alert("To book lessons or bundles, please go to the booking page.");
      return;
    }

    const priceId = STRIPE_PRICE_IDS[planId];

    if (!priceId || priceId.includes("here")) {
      alert("Price ID missing! Add real Stripe Price IDs.");
      return;
    }

    setLoading(planId);

    try {
      const res = await api.post(
        "payments/create-video-checkout",
        {
          bookingId: video._id,
          priceId,
          studentId: video.studentId?._id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );

      const data = res.data;
      if (data) {
        fetchBookedSlots();
      }
      console.log("Server response:", data);

      if (res.status !== 200) {
        alert(`Error: ${data.message || "Server error"}`);
        return;
      }

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("No checkout URL received!");
      }
    } catch (err) {
      console.error("Stripe error:", err);
      alert(`Something went wrong: ${err.message}`);
    }
  };

  return (
    <div className="overview-container">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <h2 style={{ margin: 0 }}>Recorded Lessons</h2>
        <span
          style={{
            background: hasFreeAccess ? "#14532d" : "#1a0000",
            border: `1px solid ${hasFreeAccess ? "#22c55e44" : "#ef444444"}`,
            color: hasFreeAccess ? "#22c55e" : "#ef4444",
            fontSize: "12px",
            fontWeight: 600,
            padding: "4px 12px",
            borderRadius: "20px",
          }}
        >
          {hasFreeAccess
            ? `✓ Free Access — ${subscription.price === 79.99 ? "VIP" : "Base"} Plan`
            : "🔒 No Subscription — $47 per video"}
        </span>
      </div>

      {!hasFreeAccess && (
        <div
          style={{
            background: "#1a1200",
            border: "1px solid #e6be5d44",
            borderRadius: "10px",
            padding: "12px 16px",
            marginBottom: "1.5rem",
            fontSize: "13px",
            color: "#9ca3af",
          }}
        >
          💡 Subscribe to get{" "}
          <strong style={{ color: "#e6be5d" }}>unlimited free access</strong> to
          all recorded lessons.{" "}
          <span
            style={{ color: "#e6be5d", cursor: "pointer", fontWeight: 600 }}
            onClick={() => navigate("/membership")}
          >
            View Plans →
          </span>
        </div>
      )}

      {loading ? (
        <p style={{ color: "#888" }}>Loading recordings...</p>
      ) : bookedSlots.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "3rem",
            background: "#111",
            borderRadius: "12px",
            border: "1px solid #333",
          }}
        >
          <p style={{ fontSize: "2rem", marginBottom: "1rem" }}>🎬</p>
          <p style={{ color: "#888", marginBottom: "0.5rem" }}>
            No recorded lessons yet.
          </p>
          <p style={{ color: "#555", fontSize: "13px" }}>
            Recordings appear here after your Zoom lessons are completed.
          </p>
        </div>
      ) : (
        <table className="lessons-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Duration</th>
              <th>Teacher Name</th>
              <th>Status</th>
              {/* <th>Watch</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {bookedSlots.map((rec) => (
              <React.Fragment key={rec.id}>
                <tr>
                  <td>
                    {rec.date ? new Date(rec.date).toLocaleDateString() : "N/A"}
                  </td>
                  <td>{formatSlotTime(rec.time, rec.duration)}</td>
                  <td>{rec.duration ? `${rec.duration} min` : "N/A"}</td>
                  <td>{rec.teacherId?.userId?.name}</td>
                  <td>
                    <span
                      style={{
                        color:
                          rec.status === "completed" ? "#22c55e" : "#ef4444",
                        fontWeight: 500,
                        fontSize: "13px",
                        textTransform: "capitalize",
                      }}
                    >
                      {rec.status}
                    </span>
                  </td>
                  {/* <td>
                    {hasFreeAccess && rec.status === "completed" ? (
                      <button className="lesson-btn">Watch</button>
                    ) : (
                      <button className="lesson-btn expired">Get Access</button>
                    )}
                  </td> */}
                  <td>
                    {hasFreeAccess || rec.videoPrice === 47 ? (
                      <button
                        className="lesson-btn"
                        onClick={() => {
                          setVideoModal(true);
                          setVideoUrl(rec.recordingUrl);
                        }}
                      >
                        Watch Recording
                      </button>
                    ) : (
                      <button
                        className="lesson-btn"
                        onClick={() => {
                          setPaymentModal(true);
                          setVideo(rec);
                        }}
                      >
                        $47 per Video
                      </button>
                    )}
                  </td>
                </tr>

                {expandedId === rec.id && rec.recordedLessons?.length > 0 && (
                  <tr>
                    <td colSpan="4">
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Title</th>
                            <th>Access</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rec.recordedLessons.map((lesson, index) => (
                            <tr key={lesson.id}>
                              <td>{index + 1}</td>
                              <td style={{ color: "#d1d5db" }}>
                                {lesson.title}
                              </td>
                              <td>
                                {hasFreeAccess ? (
                                  <button
                                    onClick={() =>
                                      openVideoModal(
                                        lesson.videoUrl,
                                        lesson.title,
                                      )
                                    }
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      color: "#22c55e",
                                      fontSize: "13px",
                                      fontWeight: 600,
                                      padding: 0,
                                    }}
                                  >
                                    <IoPlayCircleOutline size={18} />
                                    Watch Free
                                  </button>
                                ) : (
                                  <button
                                    onClick={() => handlePayForReplay(lesson)}
                                    disabled={payingFor === lesson.id}
                                    style={{
                                      background: "none",
                                      border: "1px solid #e6be5d55",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      color: "#e6be5d",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      padding: "4px 10px",
                                    }}
                                  >
                                    <IoLockClosedOutline size={14} />
                                    {payingFor === lesson.id
                                      ? "Loading..."
                                      : `Pay $${REPLAY_PRICE} to Watch`}
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      )}

      {videoModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setVideoModal(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="video-modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0.5rem",
              }}
            >
              <span
                style={{ color: "#fff", fontWeight: 600, fontSize: "15px" }}
              >
                {currentVideo.title}
              </span>
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => setVideoModal(false)}
              />
            </div>
            <video controls width="100%">
              <source src={videoUrl} type="video/mp4" />
            </video>
            {/* <iframe
              src={videoUrl}
              width="100%"
              height="500px"
              allow="autoplay; fullscreen"
              allowFullScreen
            /> */}
          </div>
        </div>
      )}
      {paymentModal && (
        <div
          className="video-modal-overlay"
          onClick={() => setPaymentModal(false)}
        >
          <div
            className="video-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="video-modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0.5rem",
              }}
            >
              <span
                style={{
                  color: "rgb(25,25,25)",
                  fontWeight: 600,
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
              >
                Subscription
              </span>
              <IoCloseOutline
                size={28}
                style={{ cursor: "pointer", color: "rgb(25,25,25)" }}
                onClick={() => setPaymentModal(false)}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                justifyContent: "center",
                alignItems: "start",
              }}
            >
              <p
                style={{
                  color: "rgb(30, 30, 30)",
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "22px",
                }}
              >
                This is a premium lesson available through our learning
                platform. You can unlock full access by subscribing to VIP,
                which includes all videos at no extra cost, or choose to
                purchase this single recording for $47.
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <button
                  className="lesson-btn"
                  onClick={() => navigate("/membership")}
                >
                  View Plans
                </button>
                <button
                  className="lesson-btn"
                  onClick={() => handleSubscribe("monthly")}
                >
                  $47 per Video
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Replays;
